
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MapPin } from "lucide-react";
import { toast } from "sonner";

interface CepSearchInputProps {
  onCepSearch: (cep: string) => Promise<any>;
  onFullSearch: (cep: string) => Promise<void>;
  loading: boolean;
  cepSearchInProgress: boolean;
}

export const CepSearchInput = ({
  onCepSearch,
  onFullSearch,
  loading,
  cepSearchInProgress
}: CepSearchInputProps) => {
  const [cep, setCep] = useState("");

  const handleCepChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '');
    
    if (value.length <= 8) {
      // Format with hyphen after 5 digits
      if (value.length > 5) {
        setCep(value.replace(/^(\d{5})(\d{0,3})/, '$1-$2'));
      } else {
        setCep(value);
      }
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!/^\d{8}$|^\d{5}-\d{3}$/.test(cep)) {
      toast.error("CEP inválido. Informe um CEP no formato 00000000 ou 00000-000");
      return;
    }

    const cepSemTraco = cep.replace("-", "");
    onFullSearch(cepSemTraco);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid gap-2">
        <Label htmlFor="cep" className="flex items-center gap-2">
          <MapPin className="h-4 w-4 text-muted-foreground" />
          CEP da Instalação
        </Label>
        <div className="flex gap-2">
          <Input
            id="cep"
            placeholder="00000-000"
            value={cep}
            onChange={handleCepChange}
            maxLength={9}
            className="flex-1"
          />
          <Button 
            type="submit" 
            disabled={loading} 
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Buscando...
              </>
            ) : (
              "Carregar HSP"
            )}
          </Button>
        </div>
      </div>
    </form>
  );
};
